// Vuex salesServicesPointsRequests module mutations
import { FILL_LIST, SET_FILTERING_CRITERIA, SET_PAGE } from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [SET_FILTERING_CRITERIA](state, payload) {
    const _state = state;
    _state.filteringCriteria = payload;
  },
  [SET_PAGE](state, payload) {
    const _state = state;
    _state.list.page = payload.page;
  },
};
